module.exports = __webpack_public_path__ + "static/media/delivered.081ef957.svg";


//////////////////
// WEBPACK FOOTER
// /src/assets/icons/delivered.svg
// module id = ./src/assets/icons/delivered.svg
// module chunks = 0